// Video Accessilbity : Reduced motion preference
function shouldRespectReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function shouldAutoplayVideo() {
  return !shouldRespectReducedMotion();
}

// Handle reduced motion for autoplay videos
document.addEventListener('DOMContentLoaded', function() {
  const reduceMotion = shouldRespectReducedMotion();

  if (reduceMotion) {
    document.querySelectorAll('video[autoplay]').forEach(video => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe, [contenteditable]:not([contenteditable='false'])"
    )
  ).filter(element => {
    // Filter out elements that are not visible or not interactable
    const style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      !element.hasAttribute('inert') &&
      element.offsetWidth > 0 &&
      element.offsetHeight > 0
    );
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  // If no focusable elements, make the container focusable
  if (!elements.length) {
    container.setAttribute('tabindex', '-1');
    elements = [container];
    first = last = container;
  }

  trapFocusHandlers.focusin = (event) => {
    // Only add keydown listener when focus enters the trap area
    if (container.contains(event.target)) {
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    }
  };

  trapFocusHandlers.focusout = function (event) {
    // Only remove keydown listener when focus leaves the trap area entirely
    if (!container.contains(event.relatedTarget)) {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key

    // Ensure we're still within the container
    if (!container.contains(event.target)) return;

    // Re-query elements in case they've changed
    const currentElements = getFocusableElements(container);
    if (!currentElements.length) return;

    const currentFirst = currentElements[0];
    const currentLast = currentElements[currentElements.length - 1];

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === currentLast && !event.shiftKey) {
      event.preventDefault();
      currentFirst.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (event.target === currentFirst && event.shiftKey) {
      event.preventDefault();
      currentLast.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  // Focus the element with a slight delay to ensure modal is rendered
  requestAnimationFrame(() => {
    elementToFocus.focus();

    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  });
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.quantityUpdateUnsubscriber = undefined;

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onInputChange(event) {
    this.validateQtyRules(event);
  }

  onButtonClick(event) {
    event.preventDefault();

    const cartDrawer = document.querySelector("cart-drawer");

    if (!cartDrawer?.loading) {
      const previousValue = this.input.value;

      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }

      cartDrawer?.setLoading();

      event.target.setAttribute("disabled", "disabled");
    }
  }

  validateQtyRules(event = null) {
    const value = parseInt(this.input.value, 10);
    const max = parseInt(this.input?.max ?? 0, 10);

    if (value > max) {
      if (event != null) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.input.value = max;
    }

    const buttonPlus = this.querySelector('.quantity__button[name="plus"]');

    if (max > 0) {
      buttonPlus.classList.toggle("disabled", value >= max);

      if (value >= max) {
        buttonPlus.setAttribute("disabled", "disabled");
      }
    } else {
      buttonPlus.classList.remove("disabled");
      buttonPlus.removeAttribute("disabled");
    }
  }

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('[id^="ModalClose-"]');
    this.preventPause = this.closeButton?.dataset.preventPause == "true";
    this.closeButton.addEventListener(
      "click",
      this.hide.bind(this, !this.preventPause)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide(!this.preventPause);
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide(!this.preventPause);
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide(!this.preventPause);
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.moveModal();
  }

  moveModal() {
    if (this.classList.contains("sign-up-modal__dialog")) {
      return
    };
    if (
      this.classList.contains("gift-wrap") ||
      this.classList.contains("cart-upsell")
    ) {
      document.getElementById("cart-drawer-items-container").appendChild(this);
    } else {
      document.body.appendChild(this);
    }
  }

  show(opener, pauseMedia = true) {
    if (this.classList.contains("gift-wrap") && window.screen.height < 668) {
      this.style.height = `${
        document.querySelector(".drawer__inner").scrollHeight
      }px`;
    }
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();

    // Setup focus trap with proper fallback
    const dialogElement = this.querySelector('[role="dialog"]');
    const firstFocusableElement = this.querySelector('button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])');
    const elementToFocus = firstFocusableElement || dialogElement || this;

    // Ensure the modal container is focusable for the trap
    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', '-1');
    }

    trapFocus(this, elementToFocus);
    if (pauseMedia) {
      window.pauseAllMedia();
    }
  }

  hide(pauseMedia = true) {
    const cart = document.querySelector("cart-drawer");
    if (cart && !cart.isOpen) {
      document.body.classList.remove("overflow-hidden");
    }
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");

    // Ensure focus returns to the exact button that opened the modal
    const openerButton = this.openedBy;
    removeTrapFocus();

    // Use requestAnimationFrame to ensure the modal is fully hidden before focusing
    if (openerButton && typeof openerButton.focus === 'function') {
      requestAnimationFrame(() => {
        openerButton.focus();
        // Ensure the button is visible and scrolled into view
        openerButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    if (pauseMedia) {
      window.pauseAllMedia();
    }
    if (this.classList.contains("gift-wrap") && window.screen.height < 668) {
      this.style.height = "auto";
    }
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;

    // Ensure the button has proper accessibility attributes
    if (!button.hasAttribute('aria-haspopup')) {
      button.setAttribute('aria-haspopup', 'dialog');
    }

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) {
        // Store reference to the specific button that triggered the modal
        modal.openerElement = button;
        modal.show(button, modal.dataset.preventPause == true);

        // Update aria-expanded if the button supports it
        button.setAttribute('aria-expanded', 'true');
      }
    });

    // Listen for modal close events to update aria-expanded
    document.addEventListener('modalClosed', () => {
      button.setAttribute('aria-expanded', 'false');
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

// This whole component could do with a re-write, its dawn
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.autoPlayEnabled = this.dataset.autoScroll === "true";
    // this.autoplayPaused = false;

    this.timer = this.dataset.timer ?? 3000;
    // this.pauseTimer = this.dataset.pauseTimer ?? 5000;

    // Detect reduced motion preference
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.slider = this.querySelector(':scope > [id^="Slider-"]');
    this.sliderItems = this.querySelectorAll(':scope > ul > li[id^="Slide-"]');
    this.enableSliderLooping = false;
    if (this.classList.contains("journey-carousel")) {
      this.enableSliderLooping = true;
    }

    this.sliderButtons = this.querySelector(":scope > .slider-buttons");
    if (!this.sliderButtons) {
      this.sliderButtons = this.querySelector(":scope > div > .slider-buttons");
    }
    if (this.sliderButtons) {
      this.pageNav = this.sliderButtons.querySelector(".slider-counter--nav");
      this.currentPageElement = this.sliderButtons.querySelector(
        ".slider-counter .slider-counter--current"
      );
      this.pageTotalElement = this.sliderButtons.querySelector(
        ".slider-counter .slider-counter--total"
      );
      this.sliderDots = this.sliderButtons.querySelectorAll(
        ".slider-buttons .slider-counter--dot-button"
      );
    }

    this.prevButton = this.querySelector(':scope > button[name="previous"]');
    this.nextButton = this.querySelector(':scope > button[name="next"]');

    if (!this.prevButton && this.sliderButtons) {
      this.prevButton = this.sliderButtons.querySelector(
        'button[name="previous"]'
      );
      this.nextButton = this.sliderButtons.querySelector('button[name="next"]');
    }

    if (!this.slider) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));

    if (!this.nextButton) {
      return;
    }

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    if (this.sliderDots) {
      this.sliderDots.forEach((dot) =>
        dot.addEventListener("click", this.onButtonClick.bind(this))
      );
    }

    this.highlightTabs = this.querySelectorAll(".js-highlights-tabs > h3");
    if (this.highlightTabs.length) {
      this.initHighlightTabs();
    }
    if (this.dataset.autoplayVideos == "true" && shouldAutoplayVideo()) {
      this.autoPlayVideos();
    }
  }
  autoPlay(timer) {
    // Don't start autoplay if reduced motion is preferred
    if (this.prefersReducedMotion) return;

    // Auto play uses the currently visable carousel dots to determine how many times to click the next button
    // Allows different buttons for screen sizes
    // Click events simulated to prevent modals closing. Could change event function itself in future.
    let interval = 0;
    const buttons = this.querySelectorAll(".slider-counter--dot-button");

    const visibleButtons = Array.from(buttons).filter((button) => {
      let style = window.getComputedStyle(button);
      return style.display !== "none";
    }).length;

    const resetButton = this.querySelector("button[data-step='1']");

    const intervalId = setInterval(() => {
      if (this.autoplayPaused) return;
      this.onButtonClick({
        currentTarget: this.nextButton,
        preventDefault: () => {},
      });
      const activeButton = parseInt(
        this.querySelector(".slider-counter--dot-button.active").dataset.step
      );
      interval = activeButton;
      if (interval === visibleButtons) {
        this.onButtonClick({
          currentTarget: resetButton,
          preventDefault: () => {},
        });
        interval = 0;
        // this.autoPlay(timer);
        // clearInterval(intervalId);
      }
    }, parseInt(timer));
  }

  // pauseScroll(){
  //   this.autoplayPaused = true;
  //   setInterval(() => {
  //     this.autoplayPaused = false;
  //   }, this.pauseTimer)
  // }

  connectedCallback() {
    this.initPages();
    if (this.autoPlayEnabled) {
      this.autoPlay(this.timer);
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow.length < 2) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      return;
    }
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping || !this.nextButton) return;

    if (this.slider.scrollWidth <= this.slider.clientWidth) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    if (this.pageNav) {
      for (let i = 0; i < this.pageNav.children.length; i++) {
        let tableChild = this.pageNav.children[i];
        tableChild.classList.remove("active");
      }
      this.pageNav
        .getElementsByClassName(`dot-${this.currentPage}`)[0]
        ?.classList.add("active");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;
    const currentActive = currentTarget.parentElement.querySelector(
      ".slider-counter--dot-button.active"
    );

    let step = parseInt(event.currentTarget.dataset.step) || 1;
    if (currentTarget.classList.contains("slider-counter--dot-button")) {
      if (!currentTarget.classList.contains("active")) {
        let currentStep = parseInt(currentActive.dataset.step);
        if (step > currentStep) {
          let position = step - currentStep;
          this.slideScrollPosition =
            position * this.sliderItemOffset + this.slider.scrollLeft;
        } else {
          let position = currentStep - step;
          this.slideScrollPosition =
            this.slider.scrollLeft - position * this.sliderItemOffset;
        }
      }
    } else {
      this.slideScrollPosition =
        currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });

    // The click was made by the user
    // if (event.isTrusted && this.autoPlayEnabled) {
    //   this.pauseScroll();
    // }
  }

  scrollThoughSlide() {}

  initHighlightTabs() {
    this.highlightTabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        this.highlightTabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");

        this.setAttribute("data-active-tab", index + 1);
      });
    });
  }

  scrollToSlide(slide) {
    this.slideScrollPosition = slide * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  autoPlayVideos() {
    if (!shouldAutoplayVideo()) return;
    const container = this.querySelector(".highlights-carousel ul");
    const videos = Array.from(
      this.querySelectorAll(".highlights-carousel__video")
    );

    if (!container || videos.length === 0) return;

    let currentVideo = null;
    let currentIndex = 0;
    let suppressScrollHandler = false;

    const playVideoAtIndex = (index) => {
      if (index < 0 || index >= videos.length) return;

      videos.forEach((v) => {
        if (!v.paused) v.pause();
      });

      const video = videos[index];
      currentVideo = video;
      currentIndex = index;
      video.play();
    };

    const playLeftMostVisible = () => {
      if (suppressScrollHandler) return;

      let leftMost = null;
      let leftMostOffset = Infinity;
      let leftMostIndex = -1;

      const containerRect = container.getBoundingClientRect();

      videos.forEach((video, index) => {
        const rect = video.getBoundingClientRect();

        const isVisible =
          rect.right > containerRect.left &&
          rect.left < containerRect.right &&
          rect.bottom > containerRect.top &&
          rect.top < containerRect.bottom;

        if (isVisible) {
          const offset = Math.abs(rect.left - containerRect.left);
          if (offset < leftMostOffset) {
            leftMostOffset = offset;
            leftMost = video;
            leftMostIndex = index;
          }
        }
      });

      if (leftMost && currentVideo !== leftMost) {
        playVideoAtIndex(leftMostIndex);
      }
    };

    container.addEventListener("scroll", () => {
      clearTimeout(container._scrollTimeout);
      container._scrollTimeout = setTimeout(playLeftMostVisible, 100);
    });

    // Initial play on load
    playLeftMostVisible();

    videos.forEach((video, index) => {
      video.addEventListener("ended", () => {
        const nextIndex = (index + 1) % videos.length;
        const nextVideo = videos[nextIndex];

        suppressScrollHandler = true;
        nextVideo.scrollIntoView({
          inline: "start",
          block: "nearest",
          behavior: "smooth",
        });

        setTimeout(() => {
          suppressScrollHandler = false;
          playVideoAtIndex(nextIndex);
        }, 250);
      });
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    // Don't set autoplay if reduced motion is preferred
    if (this.prefersReducedMotion) return;

    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .then(() => {
          // Add tracking data
          const elList = this.querySelectorAll(".card");
          if (window.Shopify && window.Shopify.analytics && elList) {
            elList.forEach((el) => {
              let observer;
              const sendTrackingEvent = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(el);
              };
              observer = new IntersectionObserver(sendTrackingEvent, {
                threshold: 0.5,
              });
              observer.observe(el);
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get("vbb-set-card")) {
  customElements.define(
    "vbb-set-card",
    class SetCard extends HTMLElement {
      constructor() {
        super();

        this.setHandle = this.dataset.setHandle;
      }

      updateSetPrice() {
        fetch(`${window.Shopify.routes.root}products/${this.setHandle}`)
          .then((response) => response.text())
          .then((response) => {
            console.log({ response });
            const html = new DOMParser().parseFromString(response, "text/html");
            const hasVariablePrice =
              html.querySelector("vbb-set-form").dataset.hasVariablePrice ===
              "true";
            const discountedPrice = html.querySelector(
              ".vbb-set__details__price--discounted"
            )?.innerText;

            let preDiscountedPrice = null;

            if (html.querySelector(".vbb-set__details__price--prediscounted")) {
              preDiscountedPrice = html.querySelector(
                ".vbb-set__details__price--prediscounted"
              ).innerText;
            }

            this.querySelectorAll(
              ".vbb-product-card .vbb-loading-spinner"
            ).forEach((el) => {
              if (discountedPrice) {
                el.parentElement.innerHTML = `
                <div class="card-information">
                  <span class="caption-large light"></span>
                  <div class="price price--sold-out price--on-sale">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${discountedPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                        <span class="price-item price-item--sale price-item--last">${
                          hasVariablePrice ? "From " : ""
                        }${discountedPrice}</span>
                        ${
                          preDiscountedPrice != null
                            ? `<span class="visually-hidden visually-hidden--inline">Regular price</span>
                              <span><s class="price-item price-item--regular">${preDiscountedPrice}</s></span>`
                            : ""
                        }
                      </div>
                    </div>
                  </div>
                </div>
              `;
              } else {
                const hiddenPrice =
                  el.parentElement.querySelector(".price.hidden");
                const spinner = el.parentElement.querySelector(
                  ".vbb-loading-spinner"
                );

                if (hiddenPrice) {
                  hiddenPrice.classList.remove("hidden");
                  spinner.remove();
                } else {
                  el.parentElement.innerHTML = "";
                }
              }
            });
          });
      }

      connectedCallback() {
        this.updateSetPrice();
      }
    }
  );
}

// Promise acts as a polyfill for Attentive SDK. Other components will wait for this promise to resolve before executing their code.
// Attentive does not provide a native way to check if the SDK is loaded, so we have to poll for it.
if (!window.attentiveReady) {
  window.attentiveReady = new Promise((resolve) => {
    const checkAttentive = setInterval(() => {
      if (window.__attentive) {
        clearInterval(checkAttentive);
        resolve(window.__attentive);
      }
    }, 250);
  });
}

// Swym Wishlist Plus

(() => {
  var swat;

  window.globalSwymWishlist = {
    init,
    addToWishlist,
    deleteFromWishlist,
    isLoading: false,
    lists: [],
    selectedListId: null,
  };

  function init(swat_) {
    swat = swat_;

    window.globalSwymWishlist.isLoading = true;

    fetchWishlists();
  }

  function fetchWishlists() {
    swat.fetchLists({
      callbackFn: (lists) => {
        if (lists.length) {
          window.globalSwymWishlist.lists = lists;
          window.globalSwymWishlist.selectedListId = lists[0].lid;
          window.globalSwymWishlist.isLoading = false;
          document.dispatchEvent(
            new CustomEvent("wishlist:fetch-lists:success")
          );
          return;
        }

        swat.createList({ lname: "My Wishlist" }, (list) => {
          window.globalSwymWishlist.lists = [list];
          window.globalSwymWishlist.selectedListId = list.lid;
          window.globalSwymWishlist.isLoading = false;
          document.dispatchEvent(
            new CustomEvent("wishlist:fetch-lists:success")
          );
        });
      },
    });
  }

  function addToWishlist({ productId, productUrl, variantId }) {
    var product = {
      empi: productId,
      epi: variantId,
      du: productUrl,
    };

    swat.addToList(window.globalSwymWishlist.selectedListId, product, () => {
      document.dispatchEvent(new CustomEvent("wishlist:add-to-list:success"));
      fetchWishlists();
    });
  }

  function deleteFromWishlist({ productId, productUrl, variantId }) {
    var product = {
      empi: productId,
      epi: variantId,
      du: productUrl,
    };

    swat.deleteFromList(
      window.globalSwymWishlist.selectedListId,
      product,
      () => {
        document.dispatchEvent(
          new CustomEvent("wishlist:delete-from-list:success")
        );
        fetchWishlists();
      }
    );
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(window.globalSwymWishlist.init);
})();

class TestMode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.devLog = (message) => {
      return message;
    };

    if (document.querySelector("test-mode").dataset.devLogs === "true") {
      window.devLog = (message, data) => {
        console.log(
          `%c${message}`,
          "color: #FFF; font-size: 14px; background: #000000; padding: 1rem;"
        );
        if (data) console.log(data);
      };
    }
  }
}

customElements.define("test-mode", TestMode);
